import { Grid } from "@mui/material";
import { BaseFormFieldProps, DetailsFormBaseFieldProps, DisplayProps } from "models/propTypes/wintFormPropsTypes";
import ReadOnlyFormField from "../formLayout/readOnlyFormField";
import FormField from "../formLayout/formField";

function DetailsFormBaseField<T extends BaseFormFieldProps = BaseFormFieldProps, U extends DisplayProps = DisplayProps>(
  props: T & U & DetailsFormBaseFieldProps
) {
  const { Display, Input, readonly, readonlyPassThrough, ...otherProps } = props;
  if (readonly && !readonlyPassThrough) {
    return otherProps.value !== undefined && otherProps.value !== null && otherProps.value !== "" ? (
      <Grid item sm={6}>
        <ReadOnlyFormField<U>
          direction="vertical"
          Component={Display}
          hideMainLabel
          {...(otherProps as unknown as U)}
          descriptionText={undefined}
        />
      </Grid>
    ) : (
      <></>
    );
  }

  return (
    <FormField<T>
      Component={Input}
      direction="horizontal"
      {...(otherProps as unknown as T)}
      readonly={readonlyPassThrough}
    />
  );
}

export default DetailsFormBaseField;
